import { render, staticRenderFns } from "./ProductNews.vue?vue&type=template&id=542e545d&scoped=true&"
import script from "./ProductNews.vue?vue&type=script&lang=ts&"
export * from "./ProductNews.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542e545d",
  null
  
)

export default component.exports